<template>
  <div>
    <div id="fullpage">
      <!-- 第一页 -->
      <div class="section section1">
        <div class="mengceng"></div>
        <div class="page1">
          <img src="@/assets/img/nineton.png" class="nineton_img animated-content" />
          <div class="page1_title animated-content">
            <div class="zh_title">
              <div class="title_1">为全球用户提供</div>
              <div class="title_2">有价值的产品</div>
            </div>
          </div>
        </div>
        <!-- <p class="en_title">Do well with one's heart Every little thing</p> -->
        <div class="img-container">
          <img src="@/assets/img/index_bg.png" class="pngbg"
            :style="{ left: imgLeft + 'px' }" />
        </div>
      </div>

      <!-- 第二页 -->
      <div class="section section2">
        <div class="page2">
          <div class="page_cent">
            <div class="content">
              <!-- app介绍 -->
              <div class="img_box">
                <div class="text_box">
                  <h1 class="head_name">九吨业务</h1>
                  <div class="icon_origin"></div>
                </div>
                <img class="img_log animated-content-left" :src="Business[page_app - 1].extends[0].image" />
                <p class="title animated-content-left">
                  {{ Business[page_app - 1].title }}
                </p>
                <p class="cont animated-content-left">
                  {{ Business[page_app - 1].desc }}
                </p>
                <div class="btn_list animated-content-left">
                  <div class="andio" v-if="Business[page_app - 1].extends[4].image">
                    <div class="my_btn" @mouseenter="clearTime" @mouseleave="addTime">
                      <span>安卓</span>
                      <div class="QR_code">
                        <img :src="Business[page_app - 1].extends[4].image" />
                      </div>
                    </div>
                  </div>
                  <div class="ios" v-if="Business[page_app - 1].extends[5].image">
                    <div :class="Business[page_app - 1].extends[4].image
          ? 'my_btn mar-left30'
          : 'my_btn'
          " @mouseenter="clearTime" @mouseleave="addTime">
                      <span>iOS</span>
                      <div class="QR_code">
                        <img :src="Business[page_app - 1].extends[5].image" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- app图片 -->
              <div class="app_img animated-content-rigth">
                <img class="app_tel" :src="Business[page_app - 1].extends[2].image" />
                <img :class="`${Business[page_app - 1].extends[1].class_first} `"
                  :src="Business[page_app - 1].extends[1].image" />
                <img :class="`${Business[page_app - 1].extends[1].class_two} `"
                  :src="Business[page_app - 1].extends[3].image" />
              </div>
            </div>
          </div>
          <!-- <div class="btns_bx">
            <div class="btns_bottom_box">
              <div class="img_btn">
                <img
                  v-show="page_app !== 1"
                  src="@/assets/img/back_btn.png"
                  @click="backPageApp"
                  style="cursor: pointer"
                  @mouseenter="clearTime"
                  @mouseleave="addTime"
                />
              </div>
              <div class="btns">
                <span class="page_btn">{{ page_app }}</span> /
                <span>{{ totle_app }}</span>
              </div>
              <div class="img_btn">
                <img
                  v-show="page_app !== totle_app && totle_app != 1"
                  src="@/assets/img/go_btn.png"
                  @click="goPageApp"
                  style="cursor: pointer"
                  @mouseenter="clearTime"
                  @mouseleave="addTime"
                />
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- 第三页 -->
      <div class="section section3">
        <div class="page3">
          <div class="page_cent">
            <div class="page_title animated-content">
              <div class="head_name">公司简介</div>
              <div class="icon_origin"></div>
            </div>
            <div>
              <div class="content">
                <!-- 左边文字部分 -->
                <div class="text_box">
                  <!-- <h1 class="title">重庆市九吨科技有限公司</h1> -->
                  <h1 class="title animated-content mar-bottom75">
                    重庆市九吨科技有限公司
                  </h1>
                  <!-- <p class="en_title animated-content mar-bottom75 my_title">
                    Chongqing Jiuton Technology Co., LTD
                  </p> -->
                  <!-- <div class="icon_origin mar-bottom75 animated-content"></div> -->
                  <p class="content_text mar-bottom50 animated-content">
                    成立于2013年5月23日，从重庆大学计算机实验室里的三人团队，发展成为今天拥有400余人的成熟团队。
                  </p>
                  <p class="content_text animated-content">
                    九吨科技秉承着"<span
                      class="origin_text_bold">善良正直、务实担当、创新进取、追求极致</span>"的创业理念，打造了一家年轻有活力的科技型创新企业，团队成员平均年龄26岁，一直专注于移动互联网产品的自主研发和运营，在移动App矩阵、移动广告平台两大业务板块中，拥有四十余款核心产品，累计用户超过六亿，月活跃(MAU)用户超过两千万，是西南地区为数不多的用户量突破六亿大关的移动互联网公司。2017年成立了全资子公司，重庆赋比兴科技有限公司，后将九吨科技的业务全部转移至子公司中。
                  </p>
                </div>
                <!-- 右边图片展示 -->
                <div class="img_box">
                  <!-- <img src="@/assets/img/about_log.png" /> -->
                  <div>
                    <div class="my_video">
                      <el-carousel arrow="never" @change="changeImg">
                        <el-carousel-item v-for="item in video_img" :key="item.id">
                          <div class="go_img" @click="open_video(item.id)">
                            <img :src="item.resource" />
                          </div>
                          <img class="play_img" @click="open_video(item.id)" src="@/assets/img/play_img.png" />
                        </el-carousel-item>
                      </el-carousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第四页 -->
      <div class="section section4">
        <div class="page4">
          <div class="page_cent">
            <div class="page_title"></div>
            <div class="content">
              <div class="text_box animated-content">
                <img class="about_nineton_img" src="@/assets/img/culture_nineton.png" />
                <div class="head_name">九吨新闻</div>
                <div class="icon_origin"></div>
                <div class="page">
                  <!-- <div class="img_btn">
                    <img
                      v-show="page !== 1"
                      src="@/assets/img/back_btn.png"
                      @click="backPage"
                      style="cursor: pointer"
                    />
                  </div>
                  <div class="btns">
                    <span class="page_btn">{{ page }}</span> /
                    <span>{{ totle }}</span>
                  </div>
                  <div class="img_btn">
                    <img
                      v-show="page !== totle && totle != 1"
                      src="@/assets/img/go_btn.png"
                      @click="goPage"
                      style="cursor: pointer"
                    />
                  </div> -->
                </div>
              </div>
              <div class="img_box animated-content">
                <Vuehorizontaltimeline :items="cultureList" :scrollFlag="true" :mouseFlag="true" :srcList="srcList"
                  class="time_box" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 第五页 -->
      <div class="section section6">
        <div class="page6">
          <div class="content">
            <div class="text_box animated-content-top">
              <h1 class="head_name">九吨福利</h1>
              <!-- <p class="en_title">Nintone Business</p> -->
              <div class="icon_origin"></div>
            </div>
            <div class="welfare_list">
              <div class="grid-item"></div>
              <div :class="index == 0 || index == 2 || index == 3 || index == 5
          ? 'grid-item bgd8d animated-content-top'
          : 'grid-item animated-content'
          " v-for="(item, index) in welfareList" :key="index">
                <h1 class="num">
                  <img :class="item.imgclass" :src="item.img" />
                </h1>
                <p class="title">{{ item.title }}</p>
                <p class="cont">{{ item.subTitle }}</p>
              </div>
              <!--  <div class="grid-item">
                <h1 class="num item01">
                  <img class="img02" src="@/assets/img/02.png" />
                </h1>
                <p class="title">工作时间</p>
                <p class="cont">同行业有竞争力的薪酬，五险一金，丰厚的年终奖</p>
              </div>
              <div class="grid-item bgd8d">
                <h1 class="num item01">
                  <img class="img02" src="@/assets/img/03.png" />
                </h1>
                <p class="title">餐饮零食</p>
                <p class="cont">午餐补贴，每日不同零食供应，每月豪华下午</p>
              </div>
              <div class="grid-item bgd8d">
                <h1 class="num item01">
                  <img class="img02" src="@/assets/img/04.png" />
                </h1>
                <p class="title">节日生日</p>
                <p class="cont">
                  不同节假日定制礼盒、礼品，定制生日礼物，三周年员工纪念
                </p>
              </div>
              <div class="grid-item">
                <h1 class="num item01">
                  <img class="img02" src="@/assets/img/05.png" />
                </h1>
                <p class="title">健康守护</p>
                <p class="cont">每年豪华体检套餐，每周五下午健身房锻炼时间</p>
              </div>
              <div class="grid-item bgd8d">
                <h1 class="num item02">
                  <img class="img02" src="@/assets/img/06.png" />
                </h1>
                <p class="title">旅游团建</p>
                <p class="cont">
                  国内外定制游，每月部门团建，不定期举办游戏大赛、运动会等
                </p>
              </div>
              <div class="grid-item">
                <h1 class="num item02">
                  <img class="img02" src="@/assets/img/07.png" />
                </h1>
                <p class="title">晋升成长</p>
                <p class="cont">定期公费培训，优秀员工学习基金</p>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 第六页 -->
      <div class="section section5">
        <div class="page5">
          <div class="content">
            <div class="text_box animated-content">
              <h1 class="head_name">加入九吨</h1>
              <!-- <p class="en_title">Nintone Business</p> -->
              <div class="icon_origin"></div>
              <div class="page">
                <div class="img_btn">
                  <img v-show="page_join !== 1" src="@/assets/img/back_btn.png" @click="backPageJoin"
                    style="cursor: pointer" />
                </div>
                <!-- <div class="btns">
                  <span class="page_btn">{{ page_join }}</span> /
                  <span>{{ totle_join }}</span>
                </div> -->
                <div class="img_btn">
                  <img v-show="page_join != totle_join && totle_join != 1" src="@/assets/img/go_btn.png"
                    @click="goPageJoin" style="cursor: pointer" />
                </div>
              </div>
            </div>
            <div class="img_box animated-content">
              <div v-for="(item, index) in jobsList" :key="index">
                <img :src="item.resource" />
                <p class="title">{{ item.title }}</p>
                <div class="btn" @click="goWebPage(item.extends)">查看职位</div>
              </div>
              <!--  <div>
                <img src="@/assets/img/rule.png" />
                <p class="title">高级用户运营</p>
                <div class="btn">查看职位</div>
              </div>
              <div>
                <img src="@/assets/img/rule.png" />
                <p class="title">高级用户运营</p>
                <div class="btn">查看职位</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <!-- 第七页 -->
      <div class="section section7">
        <div class="page7">
          <div class="content">
            <div class="text_box animated-content-top">
              <h1 class="head_name">联系我们</h1>
              <!-- <p class="en_title">Nintone Business</p> -->
              <div class="icon_origin"></div>
            </div>
            <div class="img_box animated-content-top">
              <p>地址：{{ info.address }}</p>
              <p class="center">电话：{{ info.tel }}</p>
              <p>邮箱：{{ info.mail }}</p>
            </div>
          </div>
          <div class="animated-content">
            <div id="map"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="xiahua" v-if="nowIndex != 6">
      <p v-if="someData == '1' && page_name == 'index'">
        <img @click="changeIndex" src="@/assets/img/xiahua.svg" />
      </p>
      <p v-else>
        <img @click="changeIndex" src="@/assets/img/xiahua_00.svg" />
      </p>
    </div>
  </div>
</template>

<script>
import fullpage from "fullpage.js";
import { mapGetters, mapActions } from "vuex";
// import { swiper.css, SwiperSlide } from 'vue-awesome-swiper'
import Vuehorizontaltimeline from "@/components/Timeline.vue";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import MyMixin from "./mixins/index";

export default {
  components: {
    Vuehorizontaltimeline,
  },
  name: "IndexPage",
  mixins: [MyMixin],
  data() {
    return {
      fillpage: null,
      page_app: 1,
      totle_app: 5,
      page: 1,
      totle: 5,
      page_join: 1,
      totle_join: 5,
      map: null,
      center: [106.50083, 29.60816], // 设置地图中心点坐标，可根据需求修改
      zoom: 13,
      cultureList: [
        {
          data: "2023-04-23",
          img: "",
          title: "你是我眼中的\"春天\"",
          content: "祝九吨的小姐姐们女神节快乐~",
        },
        {
          data: "2023-04-23",
          img: "",
          title: "你是我眼中的\"春天\"",
          content: "祝九吨的小姐姐们女神节快乐~",
        },
        {
          data: "2023-04-23",
          img: "",
          title: "你是我眼中的\"春天\"",
          content: "祝九吨的小姐姐们女神节快乐~",
        },
        {
          data: "2023-04-23",
          img: "",
          title: "你是我眼中的\"春天\"",
          content: "祝九吨的小姐姐们女神节快乐~",
        },
      ],
      video_img: [],
      culture: {},
      Business: [
        {
          id: "",
          title: "",
          subTitle: "",
          desc: "",
          sort: "",
          extends: [
            { image: "" },
            { image: "" },
            { image: "" },
            { image: "" },
            { image: "" },
            { image: "" },
            { image: "" },
          ],
        },
      ],
      NewsList: [],
      welfareList: [],
      jobsList: [],
      imgList: [
        { img: require("@/assets/img/01.png"), imgclass: "img01" },
        { img: require("@/assets/img/02.png"), imgclass: "img02" },
        { img: require("@/assets/img/03.png"), imgclass: "img03" },
        { img: require("@/assets/img/04.png"), imgclass: "img04" },
        { img: require("@/assets/img/05.png"), imgclass: "img05" },
        { img: require("@/assets/img/06.png"), imgclass: "img06" },
        { img: require("@/assets/img/07.png"), imgclass: "img07" },
      ],
      info: {
        tel: "",
        title: "",
        mail: "",
        copyright: "",
      },
      timer: null,
      scrollInterval: null,
      appTimer: null,
      nowIndex: null,
      animate: null,
      direction: -1,
      speed: 1, // 这是滚动速度，你可以根据需要进行调整
      imgLeft: 0,
      srcList: [], //大图预览,
      backPageFlag: false,
      goPageFlag: false,
      addTimer_2: null,
      addTimer_1: null,
      backPageTimer: null,
      gopageTimer: null,
      animationId: null,
      frameCount: 0,
      imgWidth: 3350,
      containerWidth: 1920,
    };
  },
  mounted() {
    this.scrollContainer = document.getElementById("scrollBox");
    this.scrollPosition = 0;
    this.animationFrameId = null;
    this.updateSomeData("1");
    // 公司简介接口
    this.getculture();
    // 公司业务接口
    this.getBusiness();
    // 公司新闻接口
    this.getNews();
    // 公司福利接口
    this.getWelfare();
    // 公司招聘接口
    this.getJobs();
    // 公司基础信息
    this.getInfo();
    this.pageIndex = this.$route.query.page ? this.$route.query.page : 1;
    this.initMap();
    this.$nextTick(() => {
      this.initSwiper();
      this.initFullPage();
      this.fillpage.moveTo(this.$route.query.page ? this.$route.query.page : 1);
      // 使用原来的滚动规则
      setTimeout(() => {
        this.handleResize();
        this.startScrolling();
        window.addEventListener("resize", this.handleResize);
      }, 1000);
    });
  },

  // 销毁fullpage
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.appTimer);
    clearTimeout(this.addTimer_2);
    clearTimeout(this.addTimer_1);
    clearTimeout(this.backPageTimer);
    clearTimeout(this.gopageTimer);
    this.timer = null;
    this.appTimer = null;
    this.addTimer_2 = null;
    this.addTimer_1 = null;
    this.gopageTimer = null;
    this.backPageTimer = null;
    if (this.fillpage) {
      this.fillpage.destroy("all");
    }
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    ...mapActions(["updateSomeData"]),
    ...mapActions(["updatePageName"]),
    initFullPage() {
      let _this = this;
      this.fillpage = new fullpage("#fullpage", {
        onLeave: function (origin, destination) {
          // 如果离开的 section 包含动画内容，移除动画类

          /* let animatedElements = origin.item.querySelectorAll(
            ".animated-content, .animated-content-left, .animated-content-top, .animated-content-rigth"
          );
          // 为每个元素移除动画类
          animatedElements.forEach((element) => {
            element.classList.remove("active");
          }); */
          _this.updateSomeData(destination.index + 1);
          /* if (destination.index - 1 == 3 || destination.index + 1 == 4) {
            clearInterval(_this.timer);
            _this.timer = null;
          } */
          if (destination.index !== 1) {
            clearInterval(_this.appTimer);
            _this.appTimer = null;
            clearTimeout(this.addTimer_2);
            clearTimeout(this.addTimer_1);
            clearTimeout(this.backPageTimer);
            clearTimeout(this.gopageTimer);
            this.addTimer_2 = null;
            this.addTimer_1 = null;
            this.gopageTimer = null;
            this.backPageTimer = null;
          }
        },

        afterLoad: function (origin, destination) {
          _this.nowIndex = destination.index;

          if (destination.index == 1) {
            _this.appTimer = setInterval(() => {
              if (_this.page_app + 1 > _this.totle_app) {
                if (document.querySelector(".fp-completely").classList) {
                  document
                    .querySelector(".fp-completely")
                    .classList.remove("active");
                }
                setTimeout(() => {
                  if (document.querySelector(".fp-completely").classList) {
                    document
                      .querySelector(".fp-completely")
                      .classList.add("active");
                  }
                  _this.page_app = 1;
                }, 800);
              } else {
                if (document.querySelector(".fp-completely").classList) {
                  document
                    .querySelector(".fp-completely")
                    .classList.remove("active");
                }
                setTimeout(() => {
                  if (document.querySelector(".fp-completely").classList) {
                    document
                      .querySelector(".fp-completely")
                      .classList.add("active");
                  }
                  _this.page_app += 1;
                }, 800);
              }
            }, 3000);
          }
        },
        normalScrollElements: "#map",

        // sectionsColor: ['#f0f0f0', '#4BBFC3', '#7BAABE', 'whitesmoke', '#000'],
        // navigationTooltips: ['Section 1', 'Section 2', 'Section 3', 'Section 4', 'Section 5'],
        // anchors: ['section1', 'section3', 'section3', 'section4', 'section5'],
        // menu: '#menu',

        // 其他fullpage配置项...
      });
    },
    initSwiper() {
      new Swiper(".swiper", {
        loop: true,
        autoplay: {
          delay: 3000,
        },
      });
    },
    initMap() {
      // eslint-disable-next-line no-undef
      this.map = new AMap.Map("map", {
        center: this.center,
        zoom: this.zoom,
      });

      // eslint-disable-next-line no-undef, no-unused-vars
      new AMap.Marker({
        position: this.center,
        map: this.map,
      });
    },
    changeImg(id) {
      this.title_id = id + 1;
    },
    // 插件路由
    navigateToSection(sectionIndex) {
      this.fillpage.moveTo(sectionIndex);
    },
    /*  // 后退
     backPage() {
       const scrollBox = document.getElementById("scrollBox");
       const scrollDistance = scrollBox.clientWidth;
       scrollBox.scrollBy({ left: -scrollDistance, behavior: "smooth" });
       this.page -= 1;
     },
     // 翻页
     goPage() {
       const scrollBox = document.getElementById("scrollBox");
       const scrollDistance = scrollBox.clientWidth;
       scrollBox.scrollBy({ left: scrollDistance, behavior: "smooth" });
       this.page += 1;
     }, */
    backPageApp() {
      if (this.backPageFlag) {
        return;
      }
      this.backPageFlag = true;
      if (document.querySelector(".fp-completely").classList) {
        document.querySelector(".fp-completely").classList.remove("active");
      }
      this.backPageTimer = setTimeout(() => {
        if (document.querySelector(".fp-completely").classList) {
          document.querySelector(".fp-completely").classList.add("active");
        }
        if (this.page_app - 1 < 0) {
          this.page_app = 0;
        } else {
          this.page_app -= 1;
        }
        this.backPageFlag = false;
      }, 800);
    },
    // 翻页
    goPageApp() {
      if (this.goPageFlag) {
        return;
      }
      this.goPageFlag = true;
      if (document.querySelector(".fp-completely").classList) {
        document.querySelector(".fp-completely").classList.remove("active");
      }
      this.gopageTimer = setTimeout(() => {
        if (document.querySelector(".fp-completely").classList) {
          document.querySelector(".fp-completely").classList.add("active");
        }
        if (this.page_app + 1 > this.Business.length) {
          this.page_app = this.Business.length;
        } else {
          this.page_app += 1;
        }
        this.goPageFlag = false;
      }, 800);
    },
    backPageJoin() {
      this.page_join -= 1;
    },
    // 翻页
    goPageJoin() {
      this.page_join += 1;
    },
    open_video(id) {
      let routeData = this.$router.resolve({ name: "video", query: { id } });
      window.open(routeData.href, "_blank");
    },
    // 获取公司简介
    async getculture() {
      const [err, res] = await this.$http.get("culture");
      if (err) {
        return;
      }
      this.culture = res;
      let videoList = [];
      res.list.forEach((item) => {
        if (item.resourceType == "video") {
          videoList.push(item);
        }
      });
      this.video_img = videoList;
    },
    // 获取公司业务
    async getBusiness() {
      const [err, res] = await this.$http.get("business");
      if (err) {
        return;
      }
      this.Business = res.list;
      this.totle_app = res.list.length;
    },
    // 获取公司新闻
    async getNews() {
      const [err, res] = await this.$http.get("news");
      if (err) {
        return;
      }
      this.cultureList = res.list;
      this.srcList = res.list.map((item) => {
        return item.extends.big_pic;
      });
      this.totle = Math.ceil(res.list.length / 2.8);
    },
    // 获取公司福利
    async getWelfare() {
      const [err, res] = await this.$http.get("welfare");
      if (err) {
        return;
      }
      res.list.forEach((item, index) => {
        item.img = this.imgList[index].img;
        item.imgclass = this.imgList[index].imgclass;
      });
      this.welfareList = res.list;
    },
    // 获取公司招聘信息
    async getJobs() {
      const [err, res] = await this.$http.get("jobs");
      if (err) {
        return;
      }
      this.jobsList = res.list;
      // this.totle_join = res.list.length
      this.totle_join = Math.ceil(res.list.length / 3);
    },
    // 获取公司基础信息
    async getInfo() {
      const [err, res] = await this.$http.get("info");
      if (err) {
        return;
      }
      this.info = res;
    },
    // 跳转招聘
    goWebPage(url) {
      window.open(url, "_blank");
    },
    changeIndex() {
      this.fillpage.moveSectionDown();
    },
    // app按钮的移入移出
    clearTime() {
      clearInterval(this.appTimer);
      this.appTimer = null;
      this.fillpage.setAllowScrolling(false);
    },
    addTime() {
      this.appTimer = setInterval(() => {
        if (this.page_app + 1 > this.totle_app) {
          if (document.querySelector(".fp-completely").classList) {
            document.querySelector(".fp-completely").classList.remove("active");
          }
          this.addTimer_1 = setTimeout(() => {
            if (document.querySelector(".fp-completely").classList) {
              document.querySelector(".fp-completely").classList.add("active");
            }
            this.page_app = 1;
          }, 800);
        } else {
          if (document.querySelector(".fp-completely").classList) {
            document.querySelector(".fp-completely").classList.remove("active");
          }
          this.addTimer_2 = setTimeout(() => {
            if (document.querySelector(".fp-completely").classList) {
              document.querySelector(".fp-completely").classList.add("active");
            }
            this.page_app += 1;
          }, 800);
        }
      }, 3000);
      this.fillpage.setAllowScrolling(true);
    },
    
    // 原来的图片滚动方法
    startScrolling() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
      }
      
      this.scrollInterval = setInterval(() => {
        this.imgLeft += this.speed * this.direction;
        
        if (this.imgLeft <= -(this.imgWidth - this.containerWidth)) {
          this.direction = 1;
        }
        if (this.imgLeft >= 0) {
          this.direction = -1;
        }
      }, 1000 / 60); // 60fps
    },
    
    // 停止滚动动画
    stopScrolling() {
      if (this.scrollInterval) {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    
    // 获取图片宽度
    handleResize() {
      // 获取图片和容器的新宽度
      const imgElement = this.$el.querySelector(".pngbg");
      if (imgElement) {
        this.imgWidth = imgElement.offsetWidth;
        this.containerWidth = this.$el.offsetWidth;
      }
    },
  },
  computed: {
    ...mapGetters(["someData"]),
    ...mapGetters(["page_name"]),
  },
};
</script>
<style scoped lang="less">
@import "../../assets/css/base.less";

.img-container {
  overflow: hidden;
  // position: relative;
}

.pngbg {
  height: 100%;
  width: 3350px;
  position: absolute;
  bottom: 0;
  left: 0;
  will-change: transform; /* 启用硬件加速 */
  transform: translateZ(0); /* 强制硬件加速 */
}

.section1 {
  position: relative;
  height: 100vh;
  /* 确保整个视口的高度 */

  .mengceng {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }

  .page1 {
    position: relative;
    height: 100vh;
    width: 100%;
    margin: 0 auto;
    overflow-x: hidden;

    .nineton_img {
      position: absolute;
      width: 370px;
      height: 739px;
      z-index: 999;
      left: 50%;
      top: 78%;
      transform: translate(-50%, -78%);
    }

    .page1_title {
      position: absolute;
      z-index: 999;
      left: 50%;
      top: 42%;
      transform: translate(-50%, -50%);

      .zh_title {
        // width: 385px;
        font-size: 77px;
        color: #ffffff;
        line-height: 108px;
        font-weight: 100;
        margin-top: 9px;
        .title_1{
          font-size: 49px;
        }
        .title_2{
          font-size: 85px;
        }
      }
    }
  }
}

.section2 {
  position: relative;

  .page2 {
    position: relative;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;

    .page_cent {
      width: 1440px;
      padding: 164px 0 0 0;
      margin: 0 auto;
      .media1();
    }

    .page_title {
      margin-bottom: 57px;
    }

    .content {
      position: relative;
      display: flex;

      // justify- ent: space-between;
      // height: 557px;
      .text_box {
        // position: relative;
        // margin-right: 70px;
        // width: 279px;
        // padding-top: 120px;
        padding-left: 40px;
        margin-bottom: 50px;

        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;
        }
      }

      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }

      .img_box {
        // padding-top: 38px;
        height: 600px;

        .img_log {
          width: 169px;
          height: 172px;
        }

        .title {
          font-size: 24px;
          font-weight: 600;
          color: #000000;
          line-height: 38px;
          padding-left: 40px;
          margin-bottom: 16px;
          font-family: "PingFang_Medium";
          margin-top: -40px;
        }

        .cont {
          font-size: 16px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
          line-height: 30px;
          padding-left: 40px;
          width: 580px;
          margin-bottom: 31px;
          font-family: PingFangSC-Regular, PingFang SC;
        }

        .btn_list {
          display: flex;
          padding-left: 40px;
          margin-bottom: 30px;
        }
      }

      .app_img {
        position: absolute;
        right: 80px;
        top: 0;

        .app_tel {
          width: 517px;
          height: 846px;
        }

        .app_time {
          width: 482px;
          height: 296px;
          position: absolute;
          bottom: 210px;
          left: -200px;
        }

        .app_banner {
          width: 455px;
          height: 177px;
          position: absolute;
          bottom: 165px;
          right: -170px;
        }

        .tianqi_app_time {
          width: 353px;
          height: 221px;
          position: absolute;
          bottom: 376px;
          left: -183px;
        }

        .tianqi_app_banner {
          width: 455px;
          height: 177px;
          position: absolute;
          bottom: 250px;
          right: -133px;
        }

        .kexiu_app_time {
          width: 398px;
          height: 271px;
          position: absolute;
          bottom: 240px;
          left: -150px;
        }

        .kexiu_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 180px;
          right: -100px;
        }

        .shouxie_app_time {
          width: 362px;
          height: 347px;
          position: absolute;
          bottom: 276px;
          left: -150px;
        }

        .shouxie_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 209px;
          right: -81px;
        }

        .meiyan_app_time {
          width: 421px;
          height: 296px;
          position: absolute;
          bottom: 240px;
          left: -220px;
        }

        .meiyan_app_banner {
          width: 353px;
          height: 177px;
          position: absolute;
          bottom: 179px;
          right: -97px;
        }

        .niannianshouzhang_app_time {
          width: 397px;
          height: 292px;
          position: absolute;
          bottom: 255px;
          left: -184px;
        }

        .niannianshouzhang_app_banner {
          width: 429px;
          height: 180px;
          position: absolute;
          bottom: 165px;
          right: -140px;
        }

        .yoyorichang_app_time {
          width: 480px;
          height: 328px;
          position: absolute;
          bottom: 210px;
          left: -254px;
        }

        .yoyorichang_app_banner {
          width: 427px;
          height: 152px;
          position: absolute;
          bottom: 190px;
          right: -108px;
        }

        .luyinzhuangjia_app_time {
          width: 173px;
          height: 609px;
          position: absolute;
          bottom: 200px;
          left: -80px;
        }

        .luyinzhuangjia_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 190px;
          right: -74px;
        }

        .jiantongkuan_app_time {
          width: 398px;
          height: 253px;
          position: absolute;
          bottom: 253px;
          left: -149px;
        }

        .jiantongkuan_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 180px;
          right: -90px;
        }

        .zy_app_time {
          width: 353px;
          height: 333px;
          position: absolute;
          bottom: 252px;
          left: -165px;
        }

        .zy_app_banner {
          width: 455px;
          height: 177px;
          position: absolute;
          bottom: 225px;
          right: -149px;
        }

        .qy_app_time {
          width: 362px;
          height: 347px;
          position: absolute;
          bottom: 240px;
          left: -134px;
        }

        .qy_app_banner {
          width: 375px;
          height: 153px;
          position: absolute;
          bottom: 180px;
          right: -80px;
        }

        .aizimu_app_time {
          width: 407px;
          height: 317px;
          position: absolute;
          bottom: 230px;
          left: -204px;
        }

        .aizimu_app_banner {
          width: 487px;
          height: 180px;
          position: absolute;
          bottom: 180px;
          right: -150px;
        }

        .yl_app_time {
          width: 398px;
          height: 278px;
          position: absolute;
          bottom: 234px;
          left: -152px;
        }

        .yl_app_banner {
          width: 434px;
          height: 156px;
          position: absolute;
          bottom: 190px;
          right: -140px;
        }
      }
    }

    .btns_bx {
      height: 340px;
      background: rgba(216, 216, 216, 0.2);
      width: 100%;
      box-sizing: border-box;

      .btns_bottom_box {
        display: flex;
        padding: 87px 0 0 212px;
        width: 1440px;
        margin: 0 auto;
      }

      img {
        width: 70px;
        height: 70px;
      }

      .img_btn {
        width: 70px;
        height: 70px;
      }

      .btns {
        font-size: 14px;
        color: #000000;
        margin: 0 35px;

        .page_btn {
          color: #e28a2b;
          font-size: 20px;
          font-weight: 600;
          line-height: 70px;
        }
      }
    }
  }

  .my_btn {
    width: 160px;
    height: 45px;
    border-radius: 23px;
    border: 1px solid #979797;
    font-size: 18px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    line-height: 45px;
    position: relative;
    cursor: pointer;

    .QR_code {
      position: absolute;
      top: 50px;
      right: 0;
      transform: scale(0);
      transition: all 0.15s;

      img {
        width: 160px;
        height: 160px;
        border-radius: 18px;
      }
    }

    &:hover {
      background: #f7931e;
      border: 1px solid #f7931e;
      box-shadow: 0px 15px 34px 0px rgba(247, 147, 30, 0.45);
      border-radius: 37px;
      color: #fff;

      & {
        .QR_code {
          position: absolute;
          top: 50px;
          right: 0;
          transform: scale(1);
          transition: all 0.15s;

          img {
            width: 160px;
            height: 160px;
            border-radius: 18px;
            box-shadow: 0px 9px 63px 0px #e8e8e8;
          }
        }
      }
    }
  }
}

.section3 {
  .page3 {
    position: relative;
    height: 100vh;
    width: 100%;
    margin: 0 auto;
    overflow: hidden;

    .page_cent {
      padding: 164px 230px 0 240px;
      .media1();

      .page_title {
        margin-bottom: 100px;
      }

      .content {
        display: flex;
        justify-content: space-between;

        .text_box {
          .title {
            font-size: 41px;
            font-weight: 600;
            color: #000000;
            line-height: 57px;
            font-family: "PingFang_Medium";
          }

          .content_text {
            font-size: 20px;
            color: #666666;
            width: 600px;
          }
        }

        .img_box {
          .play_img {
            position: absolute;
            height: 53px;
            width: 53px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 5001;
          }

          .my_video {
            // position: absolute;
            // top: -58px;
            // left: 0;
            width: 800px;
            height: 492px;
            border-radius: 20px;
            z-index: 1000;

            /deep/.el-carousel {
              height: 492px;
              border-radius: 16px;
              cursor: pointer;
            }

            /deep/.el-carousel__container {
              height: 492px;
              border-radius: 16px;
            }

            .go_img {
              img {
                width: 800px;
                height: 492px;
                border-radius: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.section4 {
  position: relative;

  .page4 {
    position: relative;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;

    .page_cent {
      padding: 164px 148px 0 240px;
      .media1();
    }

    /*     .page_title {
      margin-bottom: 57px;
    } */
    .content {
      position: relative;
      // padding: 220px 148px 0 148px;
      display: flex;
      overflow: hidden;

      // justify-content: space-between;
      .text_box {
        position: relative;
        height: 557px;
        width: 279px;

        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;

          img {
            width: 70px;
            height: 70px;
          }

          .img_btn {
            width: 70px;
            height: 70px;
          }

          .btns {
            font-size: 14px;
            color: #000000;

            .page_btn {
              color: #e28a2b;
              font-size: 20px;
              font-weight: 600;
              line-height: 70px;
            }
          }
        }
      }

      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }

      .img_box {
        width: 1258px;
      }
    }
  }
}

.section5 {
  position: relative;

  .page5 {
    position: relative;
    height: 100vh;
    margin: 0 auto;

    .content {
      position: relative;
      padding: 286px 148px 0 240px;
      display: flex;
      justify-content: space-between;
      .media1();

      .text_box {
        position: relative;
        height: 557px;
        width: 279px;

        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;

          img {
            width: 70px;
            height: 70px;
          }

          .img_btn {
            width: 70px;
            height: 70px;
          }

          .btns {
            font-size: 14px;
            color: #000000;

            .page_btn {
              color: #e28a2b;
              font-size: 20px;
              font-weight: 600;
              line-height: 70px;
            }
          }
        }
      }

      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }

      .img_box {
        display: flex;
        justify-content: space-between;
        width: 1135px;
        text-align: center;

        img {
          height: 264px;
          width: 248px;
        }

        .title {
          font-size: 32px;
          font-weight: 500;
          color: #000000;
          line-height: 45px;
          margin: 34px 0 18px 0;
        }

        .btn {
          width: 188px;
          height: 45px;
          border-radius: 23px;
          border: 1px solid #979797;
          margin: 0 auto;
          font-size: 18px;
          font-weight: 400;
          color: #000000;
          line-height: 45px;

          &:hover {
            background: #f7931e;
            border: 1px solid #f7931e;
            box-shadow: 0px 15px 34px 0px rgba(247, 147, 30, 0.45);
            border-radius: 37px;
            color: #fff;
            cursor: pointer;
            /* & {
              .QR_code {
                position: absolute;
                top: 50px;
                right: 0;
                transform: scale(1);
                transition: all 0.15s;
                img {
                  width: 160px;
                  height: 160px;
                  border-radius: 18px;
                  box-shadow: 0px 9px 63px 0px #e8e8e8;
                }
              }
            } */
          }
        }
      }
    }
  }
}

.section6 {
  .page6 {
    position: relative;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;

    .content {
      position: relative;
      padding: 164px 148px 0 240px;
      display: flex;
      .media1();

      // justify-content: space-between;
      // overflow: hidden;
      .text_box {
        position: relative;
        width: 279px;

        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;

          img {
            width: 70px;
            height: 70px;
          }

          .img_btn {
            width: 70px;
            height: 70px;
          }

          .btns {
            font-size: 14px;
            color: #000000;

            .page_btn {
              color: #e28a2b;
              font-size: 20px;
              font-weight: 600;
              line-height: 70px;
            }
          }
        }
      }

      .welfare_list {
        position: absolute;
        right: 0;
        top: 172px;
        display: flex;
        flex-wrap: wrap;
        width: 1600px;
        overflow: hidden;

        .grid-item {
          width: 392px;
          height: 397px;
          padding: 54px 54px 0 34px;
          box-sizing: border-box;

          .num {
            .img01 {
              width: 77px;
              height: 70px;
            }

            .img02 {
              width: 98px;
              height: 71px;
            }

            .img03 {
              width: 100px;
              height: 71px;
            }

            .img04 {
              width: 106px;
              height: 71px;
            }

            .img05 {
              width: 101px;
              height: 71px;
            }

            .img06 {
              width: 103px;
              height: 71px;
            }

            .img07 {
              width: 101px;
              height: 71px;
            }
          }

          .title {
            font-size: 32px;
            font-weight: 600;
            color: #000000;
            line-height: 45px;
            margin: 16px 0 18px 0;
            font-family: "PingFang_Medium";
          }

          .cont {
            font-size: 22px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.6)
          }
        }

        .bgfff {
          background: #fff;
        }

        .bgd8d {
          background: rgba(216, 216, 216, 0.1);
        }

        .hidden {
          display: none;
        }

        /*   .item01 {
          opacity: 0.3;
        } */
        /* .item02 {
          opacity: 0.6;
        } */
      }
    }
  }
}

.section7 {
  position: relative;

  // justify-content: space-between;
  .page7 {
    position: relative;
    height: 100vh;
    margin: 0 auto;
    overflow: hidden;

    .content {
      position: relative;
      padding: 164px 148px 193px 240px;
      display: flex;
      .media1();

      .text_box {
        position: relative;
        height: 130px;
        width: 279px;

        .page {
          position: absolute;
          width: 279px;
          bottom: 0;
          left: 0;
          display: flex;
          justify-content: space-between;
          text-align: center;

          img {
            width: 70px;
            height: 70px;
          }

          .img_btn {
            width: 70px;
            height: 70px;
          }

          .btns {
            font-size: 14px;
            color: #000000;

            .page_btn {
              color: #e28a2b;
              font-size: 20px;
              font-weight: 600;
              line-height: 70px;
            }
          }
        }
      }

      .about_nineton_img {
        position: absolute;
        width: 279px;
        height: 557px;
        left: 0;
        top: 0;
        z-index: -1;
      }

      .img_box {
        height: 130px;
        padding-left: 161px;

        p {
          height: 25px;
          font-size: 18px;
          font-weight: 400;
          color: #000000;
          line-height: 25px;
        }

        .center {
          margin: 25px 0;
        }
      }
    }

    #map {
      height: 558px;
    }
  }
}

.xiahua {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999999;

  img {
    cursor: pointer;
  }
}

.en_title {
  font-size: 27px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.3);
}

/deep/.el-image-viewer__actions {
  display: none !important;
}
</style>
